import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Host1, HttpHeaderToken } from 'src/app/general/variables';
import { FrmUtilSADEncode } from 'src/app/models/util/FrmUtilSADEncode';

@Injectable({
  providedIn: 'root'
})

export class UtilService {

  constructor(protected http: HttpClient) { }

  // tslint:disable-next-line: ban-types
  url: String = `${Host1}`;

  encode(frmUtilSADEncode: FrmUtilSADEncode ) {

    return this.http.post<FrmUtilSADEncode>(`${this.url}/utilSAD/encode`, frmUtilSADEncode, HttpHeaderToken());

  }


}

